import React, { useEffect, useState, useRef } from 'react';

export default function QMSessionID() {
  const sessionID = useCookie('QuantumMetricSessionID');

  return (
    <p suppressHydrationWarning className='qmSessionID'>
      {sessionID ? sessionID.substring(0, 8) : '***'}
    </p>
  );
}

function getCookieValue(name) {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(new RegExp('(^|; )' + encodeURIComponent(name) + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : undefined;
}

export function useCookie(name, pollInterval = 1000) {
  const [value, setValue] = useState(() => getCookieValue(name));
  const lastValueRef = useRef(value);

  useEffect(() => {
    let stop = false;
    let pollTimeout = null;

    // CookieStore API (modern browsers)
    if (window.cookieStore && window.cookieStore.addEventListener) {
      const handler = async () => {
        const newValue = getCookieValue(name);
        if (lastValueRef.current !== newValue) {
          lastValueRef.current = newValue;
          setValue(newValue);
        }
      };
      window.cookieStore.addEventListener('change', handler);

      return () => {
        stop = true;
        window.cookieStore.removeEventListener('change', handler);
      };
    }

    // Fallback: Polling until value is found
    const poll = () => {
      if (stop) return;
      const newValue = getCookieValue(name);
      if (lastValueRef.current !== newValue) {
        lastValueRef.current = newValue;
        setValue(newValue);
      }
      if (newValue === undefined) {
        pollTimeout = setTimeout(poll, pollInterval);
      }
    };
    poll();

    return () => {
      stop = true;
      if (pollTimeout) clearTimeout(pollTimeout);
    };
  }, [name, pollInterval]);

  return value;
}
